import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { KetchConsent, ketchPurposesGranted } from "../utils/ketchConsent";
import { updateConsent } from "../utils/rudderstack";

export const KetchConsentTag = () => {
  const ketchTagSrc = import.meta.env.VITE_KETCH_TAG_SRC;

  // Forward the visitor's Ketch purposes to RudderStack, initially and on every change
  useEffect(() => {
    if (!ketchTagSrc) return undefined;

    // Queue Ketch commands until the boot script replaces this stub; never replace a loaded Ketch
    if (typeof window.ketch !== "function") {
      window.semaphore = window.semaphore || [];
      window.ketch = (...args: unknown[]) => {
        window.semaphore?.push(args);
      };
    }

    const handler = (consent: KetchConsent) => {
      updateConsent(ketchPurposesGranted(consent));
    };
    window.ketch("on", "consent", handler);
    return () => {
      window.ketch?.("off", "consent", handler);
    };
  }, [ketchTagSrc]);

  if (!ketchTagSrc) {
    console.warn("VITE_KETCH_TAG_SRC environment variable is not set");
    return null;
  }

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          !function(){
            window.semaphore=window.semaphore||[],
            window.ketch=function(){window.semaphore.push(arguments)};
            var e=new URLSearchParams(document.location.search),
            n=document.createElement("script");
            n.type="text/javascript", 
            n.src="${ketchTagSrc}", 
            n.defer=n.async=!0,
            document.getElementsByTagName("head")[0].appendChild(n)
          }();
        `}
      </script>
    </Helmet>
  );
};
